import React from "react";
import { motion } from "framer-motion";
import arrow from "./../../../assets/aUI_Arrow_2.svg";
import elipse from "./../../../assets/FrameAgency.png";

const AboutUsIndex: React.FC = () => {
  const menuItems = [
    { number: "01", text: "Nuestro Compromiso" },
    { number: "02", text: "Nuestros Valores" },
    { number: "03", text: "Nuestra Misión" },
    { number: "04", text: "Nuestro Equipo" },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  return (
    <div className="w-full h-screen bg-black flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 overflow-hidden">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="w-full max-w-7xl grid grid-cols-1 lg:grid-cols-2 items-center gap-8 lg:gap-12"
      >
        {/* Left Image */}
        <motion.div
          initial={{ opacity: 0, x: -150, rotateY: -90, scale: 0.5 }}
          animate={{ opacity: 1, x: 0, rotateY: 0, scale: 1 }}
          transition={{
            duration: 1.2,
            ease: "backOut",
            type: "spring",
            bounce: 0.3,
          }}
          whileHover={{
            scale: 1.05,
            rotateY: 5,
            transition: { duration: 0.3 },
          }}
          className="flex items-center justify-center lg:justify-start order-2 lg:order-1"
        >
          <motion.img
            draggable={false}
            initial={{ filter: "blur(10px)" }}
            animate={{ filter: "blur(0px)" }}
            transition={{ duration: 1, delay: 1.2 }}
            src={elipse}
            alt="Agency frame illustration"
            className="w-full max-w-md lg:max-w-lg xl:max-w-xl h-auto object-contain drop-shadow-2xl"
          />
        </motion.div>

        {/* Right Menu */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.2 }}
          className="flex flex-col items-center lg:items-start justify-center gap-6 lg:gap-8 order-1 lg:order-2"
        >
          {menuItems.map((item, index) => (
            <motion.div
              key={item.number}
              initial={{ opacity: 0, x: 100, rotateX: -90, scale: 0.8 }}
              animate={{ opacity: 1, x: 0, rotateX: 0, scale: 1 }}
              transition={{ duration: 0.8, type: "spring", bounce: 0.6 }}
              whileTap={{ scale: 0.95 }}
              className="flex flex-row items-center justify-center lg:justify-start gap-4 lg:gap-6 group cursor-pointer p-4 -m-4 rounded-lg"
            >
              <motion.span
                initial={{ scale: 0, rotate: -180 }}
                animate={{ scale: 1, rotate: 0 }}
                transition={{
                  duration: 0.6,
                  delay: 1.2 + index * 0.1,
                  type: "spring",
                  bounce: 0.6,
                }}
                className="text-black text-lg sm:text-xl lg:text-2xl font-medium font-montserrat min-w-[3rem] bg-white bg-opacity-10 rounded-full w-12 h-12 flex items-center justify-center"
              >
                {item.number}
              </motion.span>

              <motion.span
                className="text-white text-lg sm:text-xl lg:text-2xl font-medium font-montserrat text-center lg:text-left"
                whileHover={{ color: "#f0f0f0" }}
              >
                {item.text}
              </motion.span>

              <motion.span
                className="group-hover:translate-x-3 w-full transition-transform duration-300"
                whileHover={{
                  rotate: 45,
                  scale: 1.5,
                  transition: { duration: 0.2 },
                }}
              >
                <img
                  draggable={false}
                  className="w-2/5 h-full filter drop-shadow-lg"
                  src={arrow}
                  alt="Arrow"
                />
              </motion.span>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>

      {/* Floating elements */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.05 }}
        transition={{ duration: 2, delay: 2 }}
        className="absolute inset-0 pointer-events-none"
      >
        {[...Array(15)].map((_, i) => (
          <motion.div
            key={i}
            initial={{
              opacity: 0,
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
            }}
            animate={{
              opacity: [0, 0.2, 0],
              y: [
                Math.random() * window.innerHeight,
                Math.random() * window.innerHeight - 100,
                Math.random() * window.innerHeight,
              ],
              x: [
                Math.random() * window.innerWidth,
                Math.random() * window.innerWidth + 50,
                Math.random() * window.innerWidth,
              ],
            }}
            transition={{
              duration: Math.random() * 4 + 3,
              delay: Math.random() * 3 + 2,
              repeat: Infinity,
              repeatDelay: Math.random() * 2 + 1,
            }}
            className="absolute w-2 h-2 bg-white rounded-full"
          />
        ))}
      </motion.div>
    </div>
  );
};

export default AboutUsIndex;
